import { Link, useNavigate } from 'react-router-dom';
import { useCategoriasMovimiento } from '../../hooks/useCategoriasMovimiento';
import { btnPrimario, pesos, tarjeta } from '../../components/ui/estilos';
import { useCajaTurno } from './useCajaTurno';
import TurnoAbierto from './TurnoAbierto';
import HistorialTurnos from './HistorialTurnos';

const n = (v: any) => parseFloat(v || 0) || 0;

export default function Turno() {
  const navigate = useNavigate();
  const cats = useCategoriasMovimiento();
  const t = useCajaTurno();
  const { cargando, turno, resumen, historial, ultimoTicket, verHistorial, setVerHistorial, activos, cobrado, efectivoEsperado, imprimirPropinas, setDialogo, setLlave } = t;

  if (cargando) return <div style={{ color: 'var(--muted)', fontSize: 17 }}>Cargando turno…</div>;
  if (verHistorial) return <HistorialTurnos turnos={historial} onVolver={() => setVerHistorial(false)} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <Link to="/dashboard" style={{ fontSize: 14, fontWeight: 700, color: 'var(--muted)', textDecoration: 'none' }}>← Inicio</Link>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Detalle del turno</h1>
        {turno && <span style={{ fontSize: 15, color: 'var(--muted)' }}>
          Desde {new Date(turno.apertura_at).toLocaleString('es-MX', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })} · {turno.usuario_apertura} · fondo {pesos(n(turno.fondo_inicial))}
        </span>}
        <div style={{ flex: 1 }} />
        {turno && <button onClick={() => setDialogo('confirmar_cierre')} style={{ ...btnPrimario, height: 48, fontSize: 16 }}>Cerrar turno</button>}
      </div>

      {!turno && (
        <section style={{ ...tarjeta, padding: 28, display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center', textAlign: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>No hay turno abierto</h2>
          <p style={{ margin: 0, fontSize: 16, color: 'var(--muted)', maxWidth: 420 }}>Abre el turno y cuenta el efectivo con el que arrancas la caja antes de empezar a cobrar.</p>
          <button onClick={() => setDialogo('abrir')} style={{ ...btnPrimario, padding: '0 32px' }}>Abrir turno</button>
          <button onClick={() => setDialogo('cajon')} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 15, fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}>Abrir cajón para contar</button>
          {historial.length > 0 && <button onClick={() => setVerHistorial(true)} style={{ background: 'none', border: 'none', color: 'var(--brand-texto)', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>Ver historial de cortes →</button>}
        </section>
      )}

      {turno && resumen && (
        <TurnoAbierto resumen={resumen} efectivoEsperado={efectivoEsperado} historial={historial} ultimoTicket={ultimoTicket}
          porMetodo={activos.map((m: any) => ({ clave: m.clave, label: m.nombre, total: cobrado(m.clave) }))}
          etiquetaCategoria={cats.label}
          onEntrada={() => setDialogo('entrada')} onSalida={() => setDialogo('salida')}
          onCancelarMov={mv => setLlave({ tipo: 'cancelar_mov', mv })}
          onRetirarPropina={p => setLlave({ tipo: 'propina', p })} onImprimirPropinas={imprimirPropinas}
          onVerCortes={() => setVerHistorial(true)} onVerTickets={() => navigate('/historial-tickets')} />
      )}

      {t.elementos}
    </div>
  );
}
